export default __webpack_public_path__ + "static/media/fire.e0bd7fca.svg";